// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form = require("../common/Components/Form.bs.js");
let React = require("react");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let SettingsPageHeader = require("./SettingsPageHeader.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let ProfilePageBiographyInformationForm_agent_graphql = require("../../__generated__/ProfilePageBiographyInformationForm_agent_graphql.bs.js");
let ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql = require("../../__generated__/ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.bs.js");

let validators = {
  biography: {
    strategy: "OnFirstSuccessOrFirstBlur",
    validate: param => ({
      TAG: "Ok",
      _0: param.biography
    })
  }
};

function initialFieldsStatuses(input) {
  return {
    biography: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    biography: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      biography: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.biography;
  let match$1;
  match$1 = typeof match !== "object" ? validators.biography.validate(input) : match._0;
  if (match$1.TAG === "Ok") {
    return {
      TAG: "Valid",
      output: {
        biography: match$1._0
      },
      fieldsStatuses: {
        biography: {
          TAG: "Dirty",
          _0: match$1,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  } else {
    return {
      TAG: "Invalid",
      fieldsStatuses: {
        biography: {
          TAG: "Dirty",
          _0: match$1,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  }
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurBiographyField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.biography, validators.biography, status => ({
            biography: status
          }));
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateBiographyField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.biography, state.submissionStatus, validators.biography, status => ({
                biography: status
              })),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  biography: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  biography: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateBiography: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBiographyField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurBiography: () => dispatch("BlurBiographyField"),
    biographyResult: Formality.exposeFieldResult(state.fieldsStatuses.biography),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.biography;
      return typeof tmp === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertVariables = ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.Internal.convertVariables;

let convertResponse = ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, ProfilePageBiographyInformationForm_UpdateAgentProfileBiographyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateAgentProfileBiographyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertFragment = ProfilePageBiographyInformationForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ProfilePageBiographyInformationForm_agent_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ProfilePageBiographyInformationForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ProfilePageBiographyInformationForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ProfilePageBiographyInformationForm_agent_graphql.node, convertFragment, fRef);
}

let AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ProfilePageBiographyInformationForm(props) {
  let agent = RescriptRelay_Fragment.useFragment(ProfilePageBiographyInformationForm_agent_graphql.node, convertFragment, props.agent);
  let match = use();
  let updateBiography = match[0];
  let form = useForm({
    biography: agent.biography
  }, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    updateBiography({
      input: {
        biography: param.biography
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let updateAgentProfileBiography = param.updateAgentProfileBiography;
      if (updateAgentProfileBiography !== undefined && updateAgentProfileBiography.__typename === "Agent") {
        return notifyOnSuccess(undefined);
      } else {
        return notifyOnFailure("An error occurred while submitting your data...");
      }
    }, undefined, undefined);
  });
  let initialBiography = React.useRef(agent.biography);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(SettingsPageHeader.SectionHeading.make, {
            title: "Biography"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
              status: form.status,
              submissionErrorToString: v => v,
              onSuccessMessage: "Account updated",
              resetForm: form.reset,
              dismissSubmissionResult: form.dismissSubmissionResult
            }),
            className: "empty:hidden"
          })
        ],
        className: "mb-6 flex flex-col gap-4"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("p", {
          children: "Tell other Top Agent Network members about yourself."
        }),
        className: "mb-8"
      }),
      JsxRuntime.jsxs("form", {
        children: [
          JsxRuntime.jsx(Form.Group.make, {
            label: "Biography",
            wide: true,
            children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(RichTextEditorV5.make, {
                initialContent: initialBiography.current,
                onChange: text => form.updateBiography((param, biography) => ({
                  biography: Form__Helpers.noneIfEmpty(biography)
                }), text),
                onBlur: param => form.blurBiography(),
                toolbar: "none",
                height: "short"
              }),
              className: "flex flex-col justify-stretch"
            })
          }),
          JsxRuntime.jsx(Form.Group.make, {
            children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              onClick: extra => Form__Helpers.preventDefault(form.submit, extra),
              disabled: !form.valid() || form.submitting || match[1],
              children: "Save"
            })
          })
        ],
        onSubmit: event => {
          event.preventDefault();
          form.submit();
        }
      })
    ],
    className: "flex flex-col"
  });
}

let make = ProfilePageBiographyInformationForm;

exports.FormConfig = FormConfig;
exports.UpdateAgentProfileBiographyMutation = UpdateAgentProfileBiographyMutation;
exports.AgentFragment = AgentFragment;
exports.make = make;
/* commitMutation Not a pure module */
